import React from "react";
import classes from "./BlackHeader.module.css";
import { useNavigate } from "react-router-dom";

const BlackHeader = ({ title, info }: { title: string; info: string }) => {
  const navigate = useNavigate();
  return (
    <div className={`${classes.background_wrapper}`}>
      <div className={`${classes.wrapper}`}>
        <div className={classes.navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={() => navigate(-1)}
          >
            <i className={`pi pi-arrow-left ${classes.close_icon}`} />
          </button>
        </div>

        <div className={classes.info_container}>
          <p className={classes.info}>{title}</p>
          <p className={classes.info_brief}>{info}</p>
        </div>
      </div>
    </div>
  );
};

export default BlackHeader;
